// extracted by mini-css-extract-plugin
export default {"challengeContainer":"styles_challengeContainer__nrD+e","challengeLabel":"styles_challengeLabel__PEGNY"};